<template>
  <v-card class="pa-4">
    <h3>{{ label }}</h3>



<div v-if="disable"  style="background: white;"><span style="color: red;">Bu öğe pasif olduğundan başvuru ekranında görüntülenmeyecektir. </span></div>

    <v-simple-table>
      <thead>
        <tr>
          <th></th>
          <th v-for="col in columns" :key="col.name" class="text-center">
            {{ col.name }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in listRows" :key="row.id" :class="row.disable===true ? 'disabled' : ''">
       
          <td>{{ row.name }}</td>
          <td v-for="col in columns" :key="col.name" class="text-center" style="vertical-align: middle;">
            <v-checkbox v-model="row.value" :value="col.name"></v-checkbox>
            <!-- :rules="listRules" -->
          </td>
        </tr>
      </tbody>
    </v-simple-table>


    <v-checkbox v-model="valid" v-show="false" :rules="listRules2()"></v-checkbox>

    <div style="color:red;" v-if="!valid">
      Lütfen boş soru bırakmayınız.
    </div>




  </v-card>
</template>

<script>
import { checkMatrixSF } from '@/plugins/FieldDataFormat.js'
import { rules } from '@/plugins/custom.js'
export default {
  name: "MultipleChoiceGridEditor",
  data() {
    return {
      valid: false,
      id: "",
      value: [],
      label: "",
      required: false,
      color: null,
      disable: false,
      hint: "",
      items: [],
      rows: [],
      columns: [],


      // rules: [v => !!v || 'Name is required'],
      placeholder: "",


    }
  },
  props: {
    editProp: {
      default: false,
      type: Boolean 
    },
    ayar: {
      // default: '{"title":"","description":""}',
      default() {
        return checkMatrixSF;
      },
      type: Object
    },
    rules: {
      default() {
        return [v => !!v || 'Name is required'];

      },
      type: Array

    }

  },
  computed: {
    listRows(){
      if (this.editProp) {
       
        return this.rows;
      }
      else
      {
         return this.rows.filter(m=>m.disable===false ); 
      }
     
    }
    // listRules() {
    //   //return this.ayar.rules.map(m => rules[m]);
    //   console.log("objectsdfsdfsd", this.rows.every(m => m.value.length > 0));
    //   let durum = this.rows.every(m => m.value.length > 0)
    //   if (!durum) {
    //     this.valid = false;
    //   }
    //   // return this.required ? this.rows.every(m=>m.value.length>0) : true;
    //   return [v => this.rows.every(m => m.value.length > 0) || 'Bu alan zorunludurx',]
    // }
  },
  methods: {
    listRules2() {
     
      if (this.ayar.required) {
        this.valid = this.rows.every(m => m.value.length > 0);
      }
      else {
        this.valid = true;
      }

      return [v => this.valid || 'Bu alan zorunludurx']
    },


    dataBind(json) {
     // console.log("Vtext Json", json);
      // let ayarJson = JSON.parse(jsonStr);
      this.title = json.title;
      this.listRules2("fxgdfg");
      // this.rules = json.rules;
      this.hint = json.hint;
      this.label = json.label;
      this.required = json.required;

      this.disable = json.disable;
      this.id = json.id;
      for (let index = 0; index < json.rows.length; index++) {
  const element = json.rows[index];
  if (!("disable" in element)) {
 element.disable = false;
}
  
}
      this.rows = json.rows;
      this.columns = json.columns
      this.header = json.header;
      console.log("Check Matrix Rows:",json.rows);
      // this.value=  json.value.lenght>0 ? json.value.split(',') : [];
      // this.value=  json.value;

    }
  },
  created() {
    this.dataBind(this.ayar);
    //console.log("Created Value:",this.ayar.value.length);
    //this.value=  this.ayar.value.length>0 ? this.ayar.value.split(',') : [];
  },
  watch: {
    value(x, y) {
      this.$emit('input', x);
      //console.log("Rules",x,y);
    },
    ayar: {
      immediate: true,
      handler(newVal, oldVal) {
        // console.log("handler:",newVal);
        // if  (newVal.required){
        // newVal.rules.push(value => !!value || 'Bu alana boş bırakılamaz.')
        // }
        console.log("object");
        this.dataBind(newVal);
        //this.slots.forEach(slot => {
        //    if (slot.availability > 10) slot.availability = 10;
        //});
      },
      deep: true
    }

  },
};
</script>

<style scoped>
::v-deep .v-input__control {
  text-align: center;
}

::v-deep .v-input--checkbox .v-input__slot {
  display: block;
}
.disabled {
  opacity: 0.5;
  background: gray;
      pointer-events: none;
    user-select: none;
} 
</style>